export interface EnvironmentBadge {
  type: 'beta' | 'dev'
  show: boolean
}

/**
 * Determines which environment badges should be shown
 * Checks for:
 * - Environment variables containing 'beta' or 'dev'
 * - Domain names containing 'beta' or 'dev'
 */
export const getEnvironmentBadges = (): EnvironmentBadge[] => {
  const badges: EnvironmentBadge[] = [
    { type: 'beta', show: false },
    { type: 'dev', show: false }
  ]

  // Check environment variables
  const envVars = import.meta.env
  const envVarString = JSON.stringify(envVars).toLowerCase()

  // Check domain name
  const hostname = window.location.hostname.toLowerCase()
  
  // Check for beta in environment variables
  if (envVarString.includes('beta') || hostname.includes('beta')) {
    badges[0].show = true
    console.log('Beta badge shown')
  }  
  // Check for dev in environment variables
  else if (envVarString.includes('dev') || hostname.includes('dev')) {
    badges[1].show = true
  }

  return badges.filter(badge => badge.show)
}

/**
 * Check if any environment badges should be shown
 */
export const shouldShowEnvironmentBadges = (): boolean => {
  return getEnvironmentBadges().length > 0
}